import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { XmlArtifact } from '../models/artifact';
import { DeveloperArtifactService } from '../services/developer-artifact.service';
import { DxLookupModule } from 'devextreme-angular';
import { DxoDropDownOptionsModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

import { FieldsetSupportDirective } from "src/app/shared/fieldset-support.directive";

@Component({
    selector: 'app-developer-artifact-xml-picker',
    templateUrl: './developer-artifact-xml-picker.component.html',
    styleUrls: ['./developer-artifact-xml-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLookupModule, DxoDropDownOptionsModule, DxTemplateModule, FieldsetSupportDirective]
})

export class DeveloperArtifactXmlPickerComponent implements OnInit, OnChanges {

    artifactDataSource: DataSource;
    artifacts: XmlArtifact[] = [];
    loadingArtifactDetails = false;
    isDisabled = false;

    selectedArtifact: XmlArtifact;
    @Input() xmlTypes: string[] = null;
    @Input() selectedArtifactId: string;
    @Output() selectedArtifactIdChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(private artifactService: DeveloperArtifactService) { }

    async ngOnInit(): Promise<void> {

        this.loadingArtifactDetails = true;
        this.artifacts = await this.artifactService.getXmlArtifacts(true, this.xmlTypes);
        this.artifacts = this.artifacts.sort((a1, a2) => a1.Name.toLowerCase().localeCompare(a2.Name.toLowerCase()));
        this.findSelectedArtifact();
        this.loadingArtifactDetails = false;

        const store = new CustomStore({
            load: (loadOptions: any) => {
                if (loadOptions.searchValue) {
                    const search = loadOptions.searchValue.toLowerCase();
                    // For now just perform the search in-memory. Maybe later on perform an actual search on the backend, if many artifacts are present.
                    return this.artifacts.filter(a =>
                        a.Name.toLowerCase().indexOf(search) >= 0 ||
                        a.Filename.toLowerCase().indexOf(search) >= 0 ||
                        a.Description.toLowerCase().indexOf(search) >= 0);
                }
                return this.artifacts;
            },
            byKey: (key: any) => key
        });

        this.artifactDataSource = new DataSource({
            store,
            paginate: false
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedArtifactId && this.selectedArtifactId) {
            this.findSelectedArtifact();
        }
    }

    findSelectedArtifact() {
        if (this.selectedArtifactId) {
            this.selectedArtifact = this.artifacts.find(a => a.ArtifactId === this.selectedArtifactId);
        }
    }

    displayExpr(item: XmlArtifact) {
        return item?.Name || 'Please select...';
    }

    artifactSelectedInternal(e: any): void {
        this.selectedArtifact = e.value as XmlArtifact;
        if (this.selectedArtifactIdChange) {
            this.selectedArtifactIdChange.emit(this.selectedArtifact?.ArtifactId);
        }
    }
}
